export interface MetricOption {
  value: string;
  label: string;
}

export const METRIC_OPTIONS: MetricOption[] = [
  { value: 'Volume', label: 'Volume' },
  { value: 'Rate', label: 'Rate' },
  { value: 'Proportion', label: 'Proportion' },
];

export interface StageOption {
  value: string;
  label: string;
}

export const STAGE_OPTIONS: StageOption[] = [
  { value: 'Inquiry', label: 'Inquiry' },
  { value: 'Application', label: 'Application' },
  { value: 'Admit', label: 'Admit' },
  { value: 'Net Deposit', label: 'Net Deposit' },
];

export interface SelectCustomStyles {
  extraBasicStyles: { padding: number; height: string };
  customClass: string;
}

export const SELECT_CUSTOM_STYLES: SelectCustomStyles = {
  extraBasicStyles: { padding: 0, height: '2' },
  customClass: '!text-sm !leading-4',
};

export interface RadioOption {
  label: string;
  value: string;
  colorClass: string;
}

export const RADIO_OPTIONS: RadioOption[] = [
  { label: 'Increase', value: 'Increase', colorClass: 'text-success-700' },
  { label: 'Maintain', value: 'Maintain', colorClass: 'text-gray-600' },
  { label: 'Decrease', value: 'Decrease', colorClass: 'text-critical-600' },
];
